define('view/controller/booking/BookingLayout',['require','lib/view/LayoutView'],function (require) {
	
	var LayoutView = require('lib/view/LayoutView');

	/**
	 * 
	 */
	return LayoutView.extend({
	
	    template: '#booking_layout',
	
	    regions: {
	    	content: '#sb_booking_content',
	    	info: '#sb_booking_info',
			time: '#sb_booking_company_time',
	    	header: '#sb_booking_header',
			back: '#sb_back_button'
	    },
	
	    getContentRegion: function () {
	    	return this.content;
	    },
	    
	    getInfoRegion: function () {
	    	return this.info;
	    },

		getTimeRegion: function () {
			return this.time;
		},
	    
	    getHeaderRegion: function () {
	    	return this.header;
	    },

		getBackButtonRegion: function () {
	    	return this.back;
		},

		onDomRefresh: function () {
			Backbone.Wreqr.radio.vent.trigger('page', 'shown', {
				'page': 'booking'
			});
		}
	    
	});
	
});
